const PROJECT_MODE = process.env.REACT_APP_PROJECT_MODE || process.env.NODE_ENV;
const DEFAULT_DEV_BACKEND_URL = "https://api.trainerx.co/";

export const BACKEND_SERVER_URL =
  process.env.REACT_APP_BACKEND_URL ||
  (PROJECT_MODE === "production"
    ? process.env.REACT_APP_BACKEND_PROD_URL
    : PROJECT_MODE === "stage"
    ? process.env.REACT_APP_BACKEND_STAGE_URL
    : process.env.REACT_APP_BACKEND_DEV_URL || DEFAULT_DEV_BACKEND_URL) || DEFAULT_DEV_BACKEND_URL;

export const CRYPTO_JS_SECRET_KEY =
  process.env.REACT_APP_CRYPTO_JS_SECRET_KEY ||
  process.env.REACT_APP_ENCRYPT_DECRYPT_SECRET_KEY || "";
